import { IMessagingService } from "../services";
import { Component } from "./component";

interface MapOptions {
    center: { 
        lat: number, 
        lng: number
    }
    zoom: number,
    icon?: string;
}

class MapComponent extends Component {
    private options: MapOptions;

    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);

        const {lat, lng, zoom, icon} = componentEl.dataset;

        this.options = {
            center: { lat: parseFloat(lat), lng: parseFloat(lng) },
            zoom: parseInt(zoom) || 18
        };
        if (icon) {
            this.options.icon = icon;
        }

        const map = new google.maps.Map(componentEl, {
            center: this.options.center,
            zoom: this.options.zoom
        });

        if (lat && lng) {
            const marker = new google.maps.Marker({
                position: this.options.center,
                map
            });
            if (this.options.icon) {
                marker.setOptions({
                    icon: {
                        url: this.options.icon,
                        scaledSize: new google.maps.Size(30, 40)
                    }
                });
            }
        }
    }

};

export { MapComponent };
